import { render, staticRenderFns } from "./CopyConfigDialog.vue?vue&type=template&id=6666fb09&scoped=true&"
import script from "./CopyConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./CopyConfigDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CopyConfigDialog.vue?vue&type=style&index=0&id=6666fb09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666fb09",
  null
  
)

export default component.exports